var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Up arrow",
    clipPath: "url(#clip0_23_1741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4853 7.28323L7.24007 3.28634C7.08557 3.09665 6.76072 3.09665 6.60622 3.28634L3.36099 7.28323C3.22114 7.45577 3.24967 7.70712 3.42438 7.8453C3.60027 7.98426 3.85499 7.9546 3.99483 7.78284L6.92315 4.17589L9.85146 7.78284C9.99265 7.95554 10.2475 7.98261 10.4219 7.8453C10.5966 7.70712 10.6251 7.45577 10.4853 7.28323Z",
    fill: "url(#paint0_linear_23_1741)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4853 9.86922L7.24003 5.87233C7.08553 5.68263 6.76069 5.68263 6.60621 5.87233L3.36098 9.86922C3.14909 10.1306 3.33837 10.5187 3.6779 10.5187H4.89486V13.7162C4.89486 13.9371 5.0763 14.1159 5.30052 14.1159H8.54576C8.76997 14.1159 8.95141 13.9371 8.95141 13.7162V10.5187H10.1684C10.5079 10.5187 10.6972 10.1306 10.4853 9.86922ZM3.42437 5.1746C3.60026 5.31316 3.85498 5.28428 3.99482 5.11214L6.92314 1.50519L9.85145 5.11214C9.99264 5.28484 10.2475 5.31191 10.4219 5.1746C10.5966 5.03642 10.6251 4.78507 10.4853 4.61253L7.24006 0.615643C7.08556 0.42595 6.76071 0.42595 6.60624 0.615643L3.361 4.61253C3.22113 4.78507 3.24966 5.03644 3.42437 5.1746Z",
    fill: "url(#paint1_linear_23_1741)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1741",
    x1: 6.92317,
    y1: 7.93313,
    x2: 6.92317,
    y2: 3.14408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3FFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#F0FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_1741",
    x1: 6.92314,
    y1: 14.1159,
    x2: 6.92314,
    y2: 0.47338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CFFAC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 13.6425,
    fill: "white",
    transform: "translate(0 0.473373)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/Uparrow.ce3f5bf669540e43dcda8390e2cbc493.svg";
export { ForwardRef as ReactComponent };